var IP_COUNTRY_COOKIE = 'geoip_country';

export { IP_COUNTRY_COOKIE };
